import { routes } from '@/app/routing/router'
import { SteamConnetPageView } from './view'

const currentRoute = routes.connectSteam

const ConnectSteamPageRoute = {
  view: SteamConnetPageView,
  route: currentRoute,
}

export { currentRoute, ConnectSteamPageRoute }
